import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { FiExternalLink, FiMenu, FiLogOut, FiUser } from 'react-icons/fi';

const Topbar = ({ toggleSidebar }) => {
  const { user, business, logout } = useAuth();
  const navigate = useNavigate();

  const publicUrl = business ? `/business/${business.slug}` : '#';

  return (
    <header className="dashboard-topbar">
      <div className="topbar-left">
        <button className="mobile-menu-toggle" onClick={() => toggleSidebar((prev) => !prev)}>
          <FiMenu />
        </button>

        <div>
          <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.1rem', fontWeight: 700 }}>
            {business ? business.businessName : 'My Business'}
          </h2>
          {business && (
            <span style={{ fontSize: '0.8rem', color: '#94A3B8' }}>
              Plan: <strong style={{ color: 'var(--secondary-500)' }}>{business.plan}</strong>
            </span>
          )}
        </div>
      </div>

      <div className="topbar-right">
        {business && (
          <a
            href={publicUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline btn-sm viewsm"
          >
            <FiExternalLink /> <span> View Page </span>
          </a>
        )}

        <div className="topbar-user">
          <div className="user-avatar">
            {user && user.name ? user.name.charAt(0).toUpperCase() : <FiUser />}
          </div>
          <span style={{ fontSize: '0.875rem', fontWeight: 600 }}>
            {user ? user.name : 'User'}
          </span>
        </div>

        <button
          onClick={() => {
            logout();
            navigate('/login');
          }}
          className="btn btn-secondary btn-sm"
          title="Logout"
        >
          <FiLogOut />
        </button>
      </div>
    </header>
  );
};

export default Topbar;
